// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"6408adab","1395":"6408adab","5309":"6408adab","5469":"6408adab","5609":"6408adab","5617":"6408adab","8190":"6408adab","9591":"6408adab","9943":"6408adab"}[chunkId] + ".chunk.css";
};